import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the VDP AI Refactor feature flag is ENABLED.
 * Used for the refactored VDP component route.
 * If this guard returns false, the legacy VDP route (without a guard) will be the fallback.
 */
export const vehicleDetailRefactorGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('vdp-AIRefactorEnabled');
};
